export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8129.e022f1df.jpg";